// Track the active state globally
let showActiveOnly = false;

const initializeActiveUsersToggle = () => {
  const toggleGroup = document.getElementById('active-users-toggle');
  if (!toggleGroup) return;

  const allButton = toggleGroup.querySelector('button:first-child');
  const activeButton = toggleGroup.querySelector('button:last-child');

  // Reset state on initialization
  allButton.classList.add('active');
  allButton.style.backgroundColor = '#f5f5f5';
  activeButton.classList.remove('active');
  activeButton.style.backgroundColor = '#fff';

  const updateCurriculumFilter = () => {
    const curriculumSelector = document.getElementById('curriculum-selector');
    if (curriculumSelector) {
      $(curriculumSelector).trigger('change');
    }
  };

  allButton.addEventListener('click', function() {
    if (!this.classList.contains('active')) {
      this.classList.add('active');
      this.style.backgroundColor = '#f5f5f5';
      activeButton.classList.remove('active');
      activeButton.style.backgroundColor = '#fff';
      updateCurriculumFilter();
    }
  });

  activeButton.addEventListener('click', function() {
    if (!this.classList.contains('active')) {
      this.classList.add('active');
      this.style.backgroundColor = '#f5f5f5';
      allButton.classList.remove('active');
      allButton.style.backgroundColor = '#fff';
      updateCurriculumFilter();
    }
  });
};

// Export both the initialization function and the state
export { initializeActiveUsersToggle, showActiveOnly }; 